import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { useAgGridUtils } from "~/pages/UserAndRoles/utils/gridUtils";
import { RoleDetailsTable } from "../RoleDetailsTable";
import { useAssignedUsersTableAgGridOptions, useFetchAssignedUsers } from "./hooks";

type AssignedUsersTabProps = {
  groupId: string | undefined;
};

export const AssignedUsersTab = ({ groupId }: AssignedUsersTabProps) => {
  const { columnDefs } = useAssignedUsersTableAgGridOptions();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      overlayNoRowsTemplate: "No users found",
    },
  });
  const { rowData, useCanopyGroupUsersQueryResult } = useFetchAssignedUsers(groupId);
  const {
    onGridReady: onUsersGridReady,
    resetFilters: resetUsersFilters,
    onFilterChanged,
    isFilterPresent,
  } = useAgGridUtils();

  return (
    <RoleDetailsTable
      queryResult={useCanopyGroupUsersQueryResult}
      title="Assigned users"
      columnDefs={columnDefs}
      rowData={rowData}
      gridOptions={gridOptions}
      onGridReady={onUsersGridReady}
      resetFilters={resetUsersFilters}
      onFilterChanged={onFilterChanged}
      isFilterPresent={isFilterPresent}
    />
  );
};
